import React, {useEffect, useState} from 'react';
import TitleAddHeader from "./TitleAddHeader";
import Address from "./Address";
import EmptyBox from "../../../components/emptyBox/EmptyBox";
import {useHistory} from "react-router-dom";
import {groupedList} from "components/utils/ListUtility";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {addressViewModel} from "../../../viewModels/Address.viewModel";
import {IsF, IsLP_MP, IsSP, IsT} from "my-styles/media/media";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import messages from "res/messages/farsi";

import ICAddIcon from "res/images/add.png";
import {Helmet} from "react-helmet";

export default function AddressList(props) {

    const history = useHistory()
    let fromBasket = (props.location.state ? props.location.state.fromBasket : false)

    const [isCancelled, setIsCancelled] = useState(false)
    const [addresses, setAddresses] = useState([])
    const [currentAddress, setCurrentAddress] = useState()
    const [showEmptyBox, setShowEmptyBox] = useState(false)
    const [deleteAddressDialogShowStatus, setDeleteAddressDialogShowStatus] = useState(false)

    const onAddressDetailClicked = (address) => {
        props.onNavigate(history, '/addressDetail', {address: address, fromBasket: fromBasket})
    }

    function requestAddresses() {
        addressViewModel.getAddresses((data) => {
            if (isCancelled) return

            let constLimit = IsLP_MP() ? 4 : IsSP() ? 3 : IsT() ? 3 : IsF() ? 2 : 1
            let emptyCount = constLimit - (data.list.length % constLimit)
            let list = groupedList(data.list, constLimit, emptyCount)
            if (list.length === 0) {
                setShowEmptyBox(true)
            }
            setAddresses(list)
        }, () => {
            setShowEmptyBox(true)
            setAddresses([])
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestSetDefaultAddress(address) {
        addressViewModel.requestSetDefaultAddress(address, () => {
            if (fromBasket) {
                props.onNavigate(history, "/orderRegister")
            } else {
                requestAddresses()
            }
            props.onAlert(messages.setDefaultAddressSuccess, ALERT_TYPES.SUCCESS)
        }, () => {
            props.onAlert(messages.setDefaultAddressError)
        }, () => {
            props.onLoading(true)
        }, () => {
            setCurrentAddress(null)
            props.onLoading(false)
        })
    }

    function requestDeleteAddress(address) {
        addressViewModel.requestDeleteAddress(address, () => {
            requestAddresses()
            props.onAlert(messages.deleteAddressSuccess, ALERT_TYPES.SUCCESS)
        }, (data) => {
            if (data && data.description && data.description === 189) {
                props.onAlert(messages.cannotDeleteAddress)
            } else {
                props.onAlert(messages.deleteAddressError)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            setCurrentAddress(null)
            props.onLoading(false)
        })
    }

    useEffect(() => {
        requestAddresses()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="full">
            <Helmet>
                <title>صرفه مارکت - لیست آدرس ها</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
            <div className="marginTopBottomSmall">
                <TitleAddHeader
                    icon={ICAddIcon}
                title={messages.myAddress}
                onIconClick={() => {
                    onAddressDetailClicked(undefined)
                }}/>
        </div>
        {addresses.length > 0 &&
        <div>
            {addresses.map((addressGroup, index1) => {
                return (<div key={index1} className="horizontalFullScreen">
                    {addressGroup.map((address, index2) => {
                        return <div key={index2} className="fourBaseInPc">
                            <Address
                                address={address}
                                onDeleteAddress={(address) => {
                                    setCurrentAddress(address)
                                    setDeleteAddressDialogShowStatus(true)
                                }}
                                onEditAddress={(address) => {
                                    onAddressDetailClicked(address)
                                }}
                                onSetDefaultAddress={(address) => {
                                    setCurrentAddress(address)
                                    requestSetDefaultAddress(address)
                                }}/>
                        </div>
                    })}
                </div>)
            })}
        </div>
        }
        {showEmptyBox &&
        <EmptyBox
            message={messages.addressesListEmpty}
            subMessageMain={messages.toAddNewAddress}
            icon={<img
                className="smallIcon"
                src={ICAddIcon} alt=""
                onClick={() => {
                    onAddressDetailClicked(undefined)
                }}/>}
            subMessage={messages.clicked}/>
        }
        <DialogMessage
            showStatus={deleteAddressDialogShowStatus}
            title={messages.deleteAddress}
            message={messages.sureDeleteAddress}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setDeleteAddressDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setDeleteAddressDialogShowStatus(false)
                if (currentAddress) {
                    requestDeleteAddress(currentAddress)
                }
            }}
        />
    </div>)

}